import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { useNotifications } from '@/features/notifications';
import { useUpdateOpportunityMutation } from '@/features/opportunities';
import { Opportunity } from '@/features/opportunities/types';

export type UseUpdateOpportunityProps = {
  opportunityId: string;
  setDrawer?: (drawer: null | string) => void;
};

export function useUpdateOpportunity({ opportunityId, setDrawer }: UseUpdateOpportunityProps) {
  const { t } = useTranslation();
  const { add } = useNotifications();

  const [updateOpportunity] = useUpdateOpportunityMutation();

  const onSubmitOpportunity = useCallback(
    (data: Partial<Opportunity>, description?: string) => {
      updateOpportunity({ id: opportunityId, data })
        .unwrap()
        .then(() => {
          add({
            id: new Date().toString(),
            title: t('Opportunity updated'),
            description: t('Your oportunity has been updated'),
          });
        })
        .catch(() => {
          add({
            id: new Date().toString(),
            title: t('ERROR'),
            description: t('There was an error updating the opportunity. Please try again later.'),
          });
        })
        .then(() => {
          if (setDrawer) {
            setDrawer(null);
          }
        });
    },
    [updateOpportunity, opportunityId, setDrawer, add, t]
  );

  return { onSubmitOpportunity };
}
